import { Comparison, type DataType } from 'vince-core/types/common';
import { ResourceType } from 'vince-core/types/common';
import { ButtonType, type LayoutDirection } from 'vince-ui/types/common';
import type { Tags } from 'vince-core/types/auth';

export enum ElementType {
    HEADER = 'HEADER',
    TEXT = 'TEXT',
    TEXT_INPUT = 'TEXT_INPUT',
    NUMBER_INPUT = 'NUMBER_INPUT',
    DATE_INPUT = 'DATE_INPUT',
    CHECKBOX = 'CHECKBOX',
    DIVIDER = 'DIVIDER',
    CONTAINER = 'CONTAINER',
    BUTTON = 'BUTTON',
    SELECT_INPUT = 'SELECT_INPUT',
}

export interface FormElement {
    id: string;
    position: number;
    type: ElementType;
}

export enum VisibilityRuleType {
    CONTEXT = 'CONTEXT',
    FIELD = 'FIELD',
}

export interface VisibilityRule {
    type: VisibilityRuleType;
    field: string;
    comparison: Comparison
    value: string;
}

export interface ContainerElement extends FormElement {
    children: FormElement[];
    direction: LayoutDirection;
    visibilityRules: VisibilityRule[]
}

export interface InputElement extends FormElement {
    label?: string;
    readonly: boolean;
    dataFieldId?: string;
}

export interface OutputElement extends FormElement {
    label: string
}

export enum ActionType {
    CANCEL = 'CANCEL',
}

export interface FormAction {
    type: ActionType;
}

export interface Button extends OutputElement {
    label: string;
    buttonType: ButtonType;
    action?: FormAction;
}

export enum HeaderSize {
    H1 = 'H1',
    H2 = 'H2',
    H3 = 'H3'
}

export interface Header extends OutputElement {
    size: HeaderSize;
}

export interface Divider extends OutputElement {
}

export enum TextSize {
    MAIN = 'MAIN',
    SUB = 'SUB'
}

export interface Text extends OutputElement {
    size: TextSize;
}

export interface TextInput extends InputElement {}

export interface Checkbox extends InputElement {
    trueValue?: string;
    falseValue?: string;
}

export interface NumberInput extends InputElement {
    minValue: number | null;
    maxValue: number | null;
    prefix?: string;
    showFractionDigits: boolean;
}

export interface DateInput extends InputElement {
    withTime: boolean;
}

export interface SelectOption {
    value: string;
    label?: string;
}

export interface SelectInput extends InputElement {
    options: SelectOption[];
}

export interface DataField {
    id: string;
    sourceField: string;
    sourceFieldType: DataType;
    sourceFieldLabel: string;
}

export interface FormData {
    sourceType: ResourceType | null;
    sourceId?: string;
    fields: DataField[];
}

export interface FormFillContext {
    nickname: string;
    lastName: string;
    firstName: string;
    email: string;
    tags: Tags,
    groups: string[];
}

export interface Form {
    id: string;
    data: FormData;
    label: string;
    description?: string;
    container: ContainerElement;
}
